import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  PaymentMethodConfigDto,
  PaymentMethodConfigListDto,
  PaymentMethodConfigFilterDto,
  CreatePaymentMethodConfigRequest,
  UpdatePaymentMethodConfigRequest,
} from '@/types/paymentMethodConfig.types';

export const paymentMethodConfigApi = {
  /** GET /api/v1/payment-methods — paginated list with optional filter */
  getList: (filter?: PaymentMethodConfigFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<PaymentMethodConfigListDto>>>('/payment-methods', {
      params: filter,
    }),

  /** GET /api/v1/payment-methods/{id} — full payment method record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<PaymentMethodConfigDto>>(`/payment-methods/${id}`),

  /** POST /api/v1/payment-methods — create a new payment method */
  create: (data: CreatePaymentMethodConfigRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/payment-methods', data),

  /** PUT /api/v1/payment-methods/{id} — update payment method */
  update: (id: string, data: UpdatePaymentMethodConfigRequest) =>
    apiClient.put<ApiResponse<object>>(`/payment-methods/${id}`, data),

  /** DELETE /api/v1/payment-methods/{id} — soft-delete */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/payment-methods/${id}`),
};
